<template>
  <span class="feature-tag" :style="{'--bg-color': tagData.backgroundColor, '--font-color': tagData.fontColor}">
    <slot>
      <span class="text--small text--bold">
        {{ $t(`common.AppFeatureTag.textKeys.${tagData.textKey}`) }}
      </span>
    </slot>
  </span>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { useTheme } from 'vuetify'

type FeatureTag = 'beta' | 'new' | 'upcoming'
type TagData = {
  backgroundColor: string;
  fontColor: string;
  textKey: string;
}

export default defineComponent({
  name: 'AppFeatureTag',
  setup () {
    const { current: theme } = useTheme()

    return {
      betaColor: {
        background: theme.value.colors['lime-lighten-3'],
        font: theme.value.colors['lime-darken-2'],
      },
      newColor: {
        background: theme.value.colors['dark-blue-lighten-4'],
        font: theme.value.colors['dark-blue-darken-2'],
      },
      upcomingColor: {
        background: theme.value.colors['grey-50'],
        font: theme.value.colors['grey-700'],
      },
    }
  },
  props: {
    tag: {
      type: String as PropType<FeatureTag>,
      required: true,
    },
  },
  computed: {
    tagData (): TagData {
      const data = {
        beta: {
          backgroundColor: this.betaColor.background,
          fontColor: this.betaColor.font,
          textKey: 'beta',
        },
        new: {
          backgroundColor: this.newColor.background,
          fontColor: this.newColor.font,
          textKey: 'new',
        },
        upcoming: {
          backgroundColor: this.upcomingColor.background,
          fontColor: this.upcomingColor.font,
          textKey: 'upcoming',
        },
      }

      return data[this.tag]
    },
  },
})
</script>

<style scoped lang="scss">
.feature-tag {
  background: var(--bg-color);
  color: var(--font-color);
  text-transform: none;
  letter-spacing: normal;

  user-select: none;
  border-radius: 4px;
  padding: 2px 8px;
}
</style>
